import React from 'react';
import * as thrift from 'thrift';
import { Buffer } from 'buffer';
import * as messages from '@radnuc/messages';
import {setConfig} from './Config';
import { t } from 'i18next';
import './i18n';
import './AuthenticationDisplay.css';


export interface AuthenticationInterface {
    authenticate: (callbackSuccess:()=>void) => void,
    authenticate_isotope_thresh?: (callbackSuccess:()=>void) => void,
    change_password: ()=>void,
    hide: ()=>void,
}


interface AuthenticationDisplayProps {
    authenticationInterface: AuthenticationInterface,
    show: boolean,
    windowType: string,
    callback?: ()=>void
}
interface AuthenticationDisplayState {
    authentication_message_color: string,
    authentication_message: string,
    password_input_val: string,
    password_new_input1_val: string,
    password_new_input2_val: string,
}

export class AuthenticationDisplay extends React.Component<AuthenticationDisplayProps, AuthenticationDisplayState> {

    password_input_element: React.RefObject<HTMLInputElement>;
    last_password_entry: string = "";
    //is_change_password: boolean = false;
    message_timer: NodeJS.Timeout | null = null;
    password_input: string="";
    abort_controller: AbortController | undefined;

    constructor(props: AuthenticationDisplayProps) {
        super(props)
        this.state = {
            authentication_message_color: '',
            authentication_message: '',
            password_input_val: '',
            password_new_input1_val: '',
            password_new_input2_val: ''
        }

        this.handleEnterClick = this.handleEnterClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handlePasswordInputKeyPress = this.handlePasswordInputKeyPress.bind(this);

        this.password_input_element = React.createRef<HTMLInputElement>();

    }

    componentDidUpdate(prevProps: AuthenticationDisplayProps){
        if(this.props.show && !prevProps.show){
            this.reset_fields();
        }
    }

    async handleEnterClick(){
        //Get password
        let password_in = this.get_password_input();
        this.last_password_entry = password_in;

        //console.log('password_in: '+password_in)
        this.show_authentication_message(t('Authenticating...',{ns:'trans'}))
        let result;
        if(this.props.windowType === 'authenticate_isotope_thresh'){
            result = this.request_password_authentication_static(password_in);
        } else {
            result = await this.request_password_authentication(password_in);
        }
        //let result;
        if(result !== null){
            //result = true;
            if(result === true){
                //Correct Password
                if(this.props.windowType==='change'){
                    const password_new_input = this.get_password_new_input1();
                    const password_new_input2 = this.get_password_new_input2();
                    if(password_new_input === password_new_input2){
                        //Match
                        this.timed_authentication_message(t("Changing password...",{ns:'trans'}),true);
                        setTimeout(()=>{
                            this.change_password_authentication(this.last_password_entry, password_new_input);
                            this.props.authenticationInterface.hide();
                        },800);
                    } else {
                        //Different
                        this.timed_authentication_message(t("New and retyped passwords must match",{ns:'trans'}));
                        setTimeout(()=>{
                            this.reset_fields();
                        },2000);
                    }
                } else {
                    this.timed_authentication_message(t('OK',{ns:'trans'}),true);
                    setTimeout(()=>{
                        if(this.props.callback)
                            this.props.callback();
                        this.props.authenticationInterface.hide();
                    },1000)
                }

            } else {
                //Wrong password
                this.timed_authentication_message(t('Incorrect password',{ns:'trans'}));
                setTimeout(()=>{
                    this.reset_fields();
                },2000);

            };
        } else {
            this.timed_authentication_message(t('Error authenticating',{ns:'trans'}));
            setTimeout(()=>{
                this.reset_fields();
            },2000);
        }
    }

    handleCancelClick(){
        //console.log('Cancel')
        if(this.abort_controller !== undefined)
            this.abort_controller.abort();
        this.props.authenticationInterface.hide();
    }

    request_password_authentication_static(password_in:string) {
        try{
            const str = 'IsotopeThresholds'
            if(password_in === str){
                return true
            } else if(password_in !== str){
                return false
            } else {
                return null
            }

        } catch(err) {
            console.log(err)
            return null;
        }
    }

    async request_password_authentication(password_in:string) {

        //const componentName = messages.ConfigurationState.ConfigComponent[messages.ConfigurationState.ConfigComponent.CONFIG];
        let packed_data: Buffer | null = null;
        let transport = new thrift.TFramedTransport(undefined, function (msg, seqid) {
            if (!msg) return;

            // Remove 4-byte header from FramedTransport
            packed_data = msg.slice(4);
        });

        let protocol = new thrift.TBinaryProtocol(transport);
        //FILL OUT QUERY FOR PASSWORD AUTHENTICATION
        let query = new messages.ConfigurationState.ConfigRequestGet();
        query.component = messages.ConfigurationState.ConfigComponent.CONFIG;
        query.check_password = password_in;
        query.write(protocol);
        transport.flush();

        if (packed_data === null)
            return;

        try{
            this.abort_controller = new AbortController();
            let port = window.location.port;
            if (window.location.port === '3000')
                port = '8301';
            let response = await fetch('http://' + window.location.hostname + ':'+port+'/TGW1hNlSwjaNFF96k4QQ9RXFNeiEqRab/' +
                `config/password_authenticate`,{
                    method: 'POST',
                    body: packed_data,
                    signal: this.abort_controller.signal
                });

            if (response.status !== 200)
                throw new Error(`Bad return code: ${response.status}`);

            const data = await response.arrayBuffer();

            const typed_data = Buffer.from(data);
            transport = new thrift.TFramedTransport(typed_data);
            protocol = new thrift.TBinaryProtocol(transport);

            const result = new messages.ConfigurationState.ConfigResponseGet();
            result.read(protocol);

            if(result.password_is_correct === true){
                return true
            } else if(result.password_is_correct === false){
                return false
            } else {
                return null
            }

        } catch(err) {
            console.log(err)
            return null;
        }
    }

    async change_password_authentication(password_in:string, password_new: string){

        //console.log('Set password: ' + password_new);

        let config = new messages.ConfigurationState.ConfigConfig();
        config.password = password_new;

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.CONFIG;
        message.config = config;
        message.password = password_in;

        await setConfig(message);

    }

    get_password_input(){
        return this.state.password_input_val;
    }
    get_password_new_input1(){
        return this.state.password_new_input1_val;
    }
    get_password_new_input2(){
        return this.state.password_new_input2_val;
    }

    timed_authentication_message(message:string, green_flag?:boolean){
        if(green_flag === undefined){
            green_flag = false;
        }
        this.show_authentication_message(message,green_flag);
        this.message_timer = setTimeout(()=>{
            this.hide_authentication_message();
            this.message_timer = null;
        },2000);
    }

    show_authentication_message(message:string, green_flag?:boolean){
        if(green_flag === undefined){
            green_flag = false;
        }
        let authentication_message_color = '';
        if(green_flag){
            authentication_message_color = 'green'
        }
        this.setState({
            authentication_message_color: authentication_message_color,
            authentication_message: message
        })

    }
    hide_authentication_message(){
        this.show_authentication_message('')
    }
    reset_fields(){
        this.setState({
            password_input_val: '',
            password_new_input1_val: '',
            password_new_input2_val: '',
         })
    }

    handlePasswordInputKeyPress(event:React.KeyboardEvent){
        var code = event.keyCode || event.which;
        if(code === 13) { //13 is the enter keycode
            //console.log('return pressed')
            this.handleEnterClick();
            event.preventDefault();
            //return false;
        }
    }
    //onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
    updateInput(event:React.ChangeEvent<HTMLInputElement>){
        this.setState({ password_input_val: event.currentTarget.value })
    }
    updateNewInput1(event:React.ChangeEvent<HTMLInputElement>){
        this.setState({ password_new_input1_val: event.currentTarget.value })
    }
    updateNewInput2(event:React.ChangeEvent<HTMLInputElement>){
        this.setState({ password_new_input2_val: event.currentTarget.value })
    }
    render(){
        let authenticationMessageClass = "authentication-message ";
        if(this.state.authentication_message !== ''){
            authenticationMessageClass += "show "+this.state.authentication_message_color;
        }
        let password_window
        if(this.props.windowType === 'authenticate' || this.props.windowType === 'authenticate_isotope_thresh'){
            let message = "";
            if (this.props.windowType === 'authenticate_isotope_thresh'){
                message = ' for Isotope Thresholds Access'
            }
            password_window =
                  <div id="password-window">
                      <div style={{display:'flex', flexDirection:'column'}}>
                        <label className="authentication-title">{t('Enter Password'+message,{ns:'trans'})}</label>
                        <div className="flex-row" style={{display:'flex', flexDirection:'row', padding:'10px'}}>
                          <form action="#0">
                              <div style={{marginRight:'5px'}}>
                                <input type="password" id="password-input" key={this.password_input} name="password"
                                    value={this.state.password_input_val} onChange={(e)=>this.updateInput(e)} onKeyPress={this.handlePasswordInputKeyPress} required placeholder=" "/>
                              </div>
                          </form>
                          <div id="password-enter" className="round-skinny-button" style={{minWidth:'50px', cursor: 'pointer'}} onClick={() => this.handleEnterClick()}>{t('Enter',{ns:'trans'})}</div>
                          <div id="password-cancel" className="round-skinny-button" style={{minWidth:'50px', cursor: 'pointer'}} onClick={() => this.handleCancelClick()}>{t('Cancel',{ns:'trans'})}</div>
                        </div>
                        <div id="password-message " className={authenticationMessageClass}>{this.state.authentication_message}</div>
                      </div>
                  </div>
        } else if(this.props.windowType === 'change'){
            password_window =
                  <div id="password-change-window">
                      <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                        <label className="authentication-title">{t('Current Password',{ns:'trans'})}</label>
                        <div className="flex-row" style={{display:'flex', flexDirection:'row', padding:'10px'}}>
                            <form action="#0">
                                <div style={{marginRight:'5px'}}>
                                    <input type="password" id="password-change-input" name="password"
                                    value={this.state.password_input_val} onChange={(e)=>this.updateInput(e)} onKeyPress={this.handlePasswordInputKeyPress} required placeholder=" "/>
                                </div>
                            </form>
                        </div>
                        <label className="authentication-title">{t('New Password',{ns:'trans'})}</label>
                        <div className="flex-row" style={{display:'flex', flexDirection:'row', padding:'10px'}}>
                            <form action="#0">
                                <div style={{marginRight:'5px'}}>
                                    <input type="password" id="password-change-new" name="password"
                                    value={this.state.password_new_input1_val} onChange={(e)=>this.updateNewInput1(e)} onKeyPress={this.handlePasswordInputKeyPress} required placeholder=" "/>
                                </div>
                            </form>
                        </div>
                        <label className="authentication-title">{t('Retype New Password',{ns:'trans'})}</label>
                        <div className="flex-row" style={{display:'flex', flexDirection:'row', padding:'10px'}}>
                            <form action="#0">
                                <div style={{marginRight:'5px'}}>
                                    <input type="password" id="password-change-retype" name="password"
                                    value={this.state.password_new_input2_val} onChange={(e)=>this.updateNewInput2(e)}  required placeholder=" "/>
                                </div>
                            </form>
                            <div id="password-enter" className="round-skinny-button" style={{minWidth:'50px', cursor: 'pointer'}} onClick={() => this.handleEnterClick()}>{t('Change',{ns:'trans'})}</div>
                            <div id="password-cancel" className="round-skinny-button" style={{minWidth:'50px', cursor: 'pointer'}} onClick={() => this.handleCancelClick()}>{t('Cancel',{ns:'trans'})}</div>
                          </div>
                          <div id="password-message " className={authenticationMessageClass}>{this.state.authentication_message}</div>
                      </div>
                  </div>


        }
        let body;
        if(this.props.show){
            body =
                <div id="authentication-container" onContextMenu={(e)=> e.preventDefault()}>
                    {password_window}
                    <div id="authentication-backdrop"></div>
                </div>
        }
        return(
            <>
                {body}
            </>
        );

    }

}
export default AuthenticationDisplay
